const extractVoucherPinFromBarcode = (barcode: string): string | null => {
  if (barcode.length < 16) return null

  const pinRegex = /^[0-9]{4}$/
  const pin = barcode.slice(12)

  if (pinRegex.test(pin)) {
    return pin
  }

  return null
}

export { extractVoucherPinFromBarcode }
